import { registerAppLinks } from "@shared/services/appLinkRegistry";

registerAppLinks([
  {
    uriExpression: "twin-edit.asset.it.*",
    routeName: "itAssetManagementDetail",
  },
]);
